import { Component, Input } from '@angular/core';
import { UserService } from '../services';

@Component({
    selector: 'app-right-nav',
    styles: [`
        .mat-tab-label-active {
            opacity: 1;
        }
    `],
    template: `
        <nav class="appNav" mat-tab-nav-bar style="border-bottom: none;">
                <a mat-tab-link 
                   *ngIf="hasCurrentUser && !userIsCatalogManager"
                   [routerLink]="['/search']" 
                   [active]="searchLinkActive.isActive" 
                   routerLinkActive #searchLinkActive="routerLinkActive" 
                   matTooltip="Search" 
                   matTooltipPosition="below"
                   style="min-width: 64px; padding: 0 16px; color: white;"><mat-icon>search</mat-icon></a>
                <a mat-tab-link 
                   *ngIf="hasCurrentUser"
                   [routerLink]="['/settings']" 
                   [active]="settingsLinkActive.isActive" 
                   routerLinkActive #settingsLinkActive="routerLinkActive"
                   matTooltip="Settings" 
                   matTooltipPosition="below"
                   style="min-width: 64px; padding: 0 16px; color: white;"><mat-icon>settings</mat-icon></a>
                <a mat-tab-link 
                   *ngIf="helpWidgetActive" 
                   (click)="help()" 
                   style="min-width: 64px; padding: 0 16px; color: white;">
                    <mat-icon>help_outline</mat-icon>
                </a>
            </nav>
    `
})
export class AppRightNavigationComponent {
    @Input() hasCurrentUser = true;
    userIsCatalogManager: boolean;

    constructor(private userService: UserService) {
        this.userIsCatalogManager = this.userService.isCurrentUserCatalogManager();
    }

    get helpWidgetActive(): boolean {
        return !!(window as any).supportHeroWidget;
    }

    help(): void {
        (window as any).supportHeroWidget.show();
    }
}
